import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {ModalForm} from "~/components";
import {InputField} from "~/components/Forms";

const schema = Yup.object().shape({
	name: Yup.string().required('Vui lòng nhập tên dự án'),
	root_url: Yup.string().required('Vui lòng nhập URL website'),
});

/**
 * Modal tạo/sửa Dự án — dùng ModalForm dùng chung (header gradient + footer nút) và
 * hệ thống Form chuẩn (react-hook-form + yupResolver + InputField trong scope `.form`).
 */
function ProjectFormModal({open, title = 'Tạo dự án', submitText = 'Tạo dự án', submitting, defaultValues, onCancel, onSubmit}) {

	const {control, handleSubmit, reset, formState: {errors}} = useForm({
		defaultValues: {name: '', root_url: '', ...defaultValues},
		resolver: yupResolver(schema),
	});

	// Nạp lại giá trị mỗi khi mở (phục vụ chế độ sửa).
	useEffect(() => {
		if (open) reset({name: '', root_url: '', ...defaultValues});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-folder-plus"
			title={title}
			subtitle="Một dự án là một website, chứa nhiều công cụ SEO"
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText={submitText}
			loading={submitting}
		>
			<Controller control={control} name="name" render={({field}) => (
				<InputField label="Tên dự án" placeholder="VD: Website Sikido" errors={errors} {...field} />
			)} />
			<Controller control={control} name="root_url" render={({field}) => (
				<InputField label="URL website" placeholder="https://sikido.vn" errors={errors} {...field} />
			)} />
		</ModalForm>
	);
}

export default ProjectFormModal;
